import React, { useEffect } from 'react';
import { useWatchlist } from '../useContext/WatchlistContext';

/**
 * Simple test component to debug watchlist issues
 */
const WatchlistSimpleTest = () => {
  const { 
    watchlist, 
    favorites, 
    loading, 
    addToWatchlist, 
    addToFavorites,
    toggleWatchlist,
    toggleFavorites 
  } = useWatchlist();

  // Test movie
  const testMovie = {
    id: 550,
    title: 'Fight Club',
    type: 'movie',
    poster_path: '/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
    imgSrc: 'https://image.tmdb.org/t/p/w500/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
    vote_average: 8.4,
    release_date: '1999-10-15',
    overview: 'A ticking-time-bomb insomniac and a slippery soap salesman channel primal male aggression into a shocking new form of therapy.',
    adult: false
  };

  // Log state changes
  useEffect(() => {
    console.log('=== WATCHLIST SIMPLE TEST ===');
    console.log('Loading:', loading);
    console.log('Watchlist:', watchlist);
    console.log('Favorites:', favorites);
    console.log('Watchlist length:', watchlist.length);
    console.log('Favorites length:', favorites.length);
    console.log('============================');
  }, [watchlist, favorites, loading]);

  const handleTestAdd = () => {
    console.log('Testing add to watchlist...');
    toggleWatchlist(testMovie);
  };

  const handleTestFavorites = () => {
    console.log('Testing add to favorites...');
    toggleFavorites(testMovie);
  };

  return (
    <div className="container mt-5 text-white">
      <h2>Watchlist Simple Test</h2>
      
      <div className="mb-4">
        <h4>Current State:</h4>
        <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
        <p><strong>Watchlist Count:</strong> {watchlist.length}</p>
        <p><strong>Favorites Count:</strong> {favorites.length}</p>
      </div>

      <div className="mb-4">
        <h4>Watchlist Items:</h4>
        {watchlist.length > 0 ? (
          <ul>
            {watchlist.map(item => (
              <li key={`${item.type}-${item.id}`}>
                {item.title} ({item.type}) - Added: {new Date(item.addedAt).toLocaleString()}
              </li>
            ))}
          </ul>
        ) : (
          <p>No items in watchlist</p>
        )}
      </div>

      <div className="mb-4">
        <h4>Favorites Items:</h4>
        {favorites.length > 0 ? (
          <ul>
            {favorites.map(item => (
              <li key={`${item.type}-${item.id}`}>
                {item.title} ({item.type}) - Added: {new Date(item.addedAt).toLocaleString()}
              </li>
            ))}
          </ul>
        ) : (
          <p>No items in favorites</p>
        )}
      </div>

      <div className="mb-4">
        <h4>Test Actions:</h4>
        <button 
          onClick={handleTestAdd} 
          className="btn btn-primary me-2" 
          disabled={loading}
        >
          Add Fight Club to Watchlist
        </button>
        <button 
          onClick={handleTestFavorites} 
          className="btn btn-danger me-2" 
          disabled={loading}
        >
          Add Fight Club to Favorites
        </button>
      </div>

      <div className="mb-4">
        <h4>Local Storage Check:</h4>
        <p><strong>watchlist:</strong> {localStorage.getItem('watchlist') || 'Empty'}</p>
        <p><strong>favorites:</strong> {localStorage.getItem('favorites') || 'Empty'}</p>
      </div>

      <div className="mb-4">
        <h4>Navigation:</h4>
        <a href="/watchlist" className="btn btn-info me-2">Go to Watchlist Page</a>
        <a href="/watchlist?tab=favourite" className="btn btn-info">Go to Favorites Tab</a>
      </div>
    </div>
  );
};

export default WatchlistSimpleTest;
